export function chunk<T>(items: T[], size: number): T[][] {
  if (size <= 0) throw new Error('La taille de lot doit être positive.');
  const result: T[][] = [];
  for (let index = 0; index < items.length; index += size) {
    result.push(items.slice(index, index + size));
  }
  return result;
}
